import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { Translate } from '@/common/components/Translate/Translate';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';

export type TITSinglePaymentCardModalProps = {
  onClose: () => void;
};

export function ITSinglePaymentCardModal({
  onClose,
}: TITSinglePaymentCardModalProps) {
  const { t } = useTranslation();
  return (
    <ModalLearning.Root onClose={onClose}>
      <ModalLearning.Step
        title={t('dashboard.home.it.single_payment.card_modal.step1.title')}
        description={
          <Translate
            parent={BodyText}
            i18nKey="dashboard.home.it.single_payment.card_modal.step1.description"
          />
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-single-payment-campaign.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_launching_strategy_banner_home_learning_center_step1_page'
          );
        }}
      />
      <ModalLearning.Step
        title={t('dashboard.home.it.single_payment.card_modal.step2.title')}
        description={
          <Translate
            parent={BodyText}
            i18nKey="dashboard.home.it.single_payment.card_modal.step2.description"
          />
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-single-payment-cards.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_launching_strategy_banner_home_learning_center_step2_page'
          );
        }}
      />
    </ModalLearning.Root>
  );
}
